import { trackTimeDivisionToggle } from './timeDivisionToggle/timeDivisionToggle.tracking';
import { trackDatePicker } from './datePicker/datePicker.tracking';
import { trackTopListings } from './topListings/topListings.tracking';

export const LISTINGS_BENCHMARK_TRACKING = {
  trackTimeDivisionToggle,
  trackDatePicker,
  trackTopListings,
};
